import { render, staticRenderFns } from "./IncidentReportTile.vue?vue&type=template&id=40a51c8a&scoped=true&"
import script from "./IncidentReportTile.vue?vue&type=script&lang=ts&"
export * from "./IncidentReportTile.vue?vue&type=script&lang=ts&"
import style0 from "./IncidentReportTile.vue?vue&type=style&index=0&id=40a51c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a51c8a",
  null
  
)

export default component.exports